export interface PdfAnalysisOptions {
  profile: 'safe' | 'deep' | string;
  RunBVPDF: boolean;
  RunSLPDOS: boolean;
  RunDCFPDF: boolean;
  RunMRPDF: boolean;
}

export const DEFAULT_PDF_ANALYSIS_OPTIONS: PdfAnalysisOptions = {
  profile: 'safe',
  RunBVPDF: true,
  RunSLPDOS: true,
  RunDCFPDF: true,
  RunMRPDF: true,
};
